<template>
  <div class="card">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col blue">
              <h3><i class="fas fa-star-half-alt"></i>Moody's Rating</h3>
            </div>
            <div class="text-right">
              <!-- <a href="#" class="moreinfo"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
            </div>
        </div>
      </div>
      <div class="card-body">
        <div class="chart">
           <canvas id="moodyRating"></canvas>

            <!-- <img src="../../../../assets/img/03.png" class="img-fluid"> -->
        </div>
      </div>
  </div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";
// import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
export default {
  name: "moodysRating",
   components: {
  },
  data() {
    return {
      accessToken : null,
      moodyChartOptions: {
                            type: 'bar',
                            data: {
                              labels: [],
                              datasets: [{
                                label: '',
                                data: [],
                                backgroundColor: "#0084CC",
                                barPercentage: 0.2,
                                borderWidth: 1
                              }]
                            },
                            options: {
                              scales: {
                                yAxes: [{
                                  ticks: {
                                    beginAtZero: true,
                                    userCallback: function(label) {
                                      // when the floored value is the same as the value we have a whole number
                                      if (Math.floor(label) === label) {
                                          return label;
                                      }

                                  },
                                  },
                                  scaleLabel: {
                                    display: true,
                                    labelString: 'Par Value'
                                  }

                                }],
                                xAxes: [{
                                  gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                  },
                                  scaleLabel: {
                                    display: true,
                                    labelString: 'Rating'
                                  }

                                }, ]
                              },
                              legend: {
                                display: false
                              },
                              plugins: {
                                labels: {
                                  render: function () {
                                    return '';
                                  },
                                }
                              } 
                            }
                          },
      moodyData: {},
      myChart : null
    };
  },
  methods: {
    getMoodyData(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/rating?status=NEW",
            auth
        )
        .then(result => {
          //console.log(result);
          this.moodyData = result.data.moody
          this.setMoodyData();
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    setMoodyData(){
      
      this.moodyChartOptions.data.labels = this.moodyData.map((x) => { return x.rating });
      this.moodyChartOptions.data.datasets[0].data = this.moodyData.map((x) => { return x.value });
      this.moodyChartOptions.data.datasets[0].data = this.moodyData.map((x) => { return x.value });
      //this.moodyChartOptions.data.datasets[0].backgroundColor = ["#fff15c", "#08ffb1", "#8c98de", "#de8cce", "#c44f5a", "#bd5384"];
      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("moodyRating");
      this.myChart = new window.Chart(ctx, {
        type: this.moodyChartOptions.type,
        data: this.moodyChartOptions.data,
        options: this.moodyChartOptions.options
      });
    }
  },
  mounted() {
  this.$cognitoAuth.getIdToken((err, result) => {
    if (err) {
      console.log("accessToken is not found", err);
    } else {
      this.accessToken = result;
      this.getMoodyData();
    }
    }); 
  }
};
</script>